<div class="saved-search-edit" [class.saved-search-edit--edit]="data.savedSearch != null">

    <div class="saved-search-edit-header">

        @let title = (data.savedSearch != null ? 'ADD_EDIT_SAVED_SEARCH_DIALOG.TITLES.EDIT_SAVED_SEARCH' :
        'ADD_EDIT_SAVED_SEARCH_DIALOG.TITLES.ADD_SAVED_SEARCH') | translate;

        <div class="saved-search-edit-header-title rpc-title-font" [title]="title">
            {{title}}
        </div>

        <rpc-button class="saved-search-edit-header-submit" [color]="'accent'" [disabled]="isFormInvalid"
            [text]="'ADD_EDIT_SAVED_SEARCH_DIALOG.BUTTONS.SAVE'" (clicked)="onSave()">
        </rpc-button>

        <rpc-button class="saved-search-edit-header-close" [iconName]="'cross'"
            [title]="'ADD_EDIT_NOTE_DIALOG.BUTTONS.CLOSE'" (clicked)="onClose()">
        </rpc-button>

    </div>

    <saved-search-form class="saved-search-edit-body" [savedSearch]="data.savedSearch"
        [savedSearches]="data.savedSearches" [folders]="folders$ | async" [folderId]="data.folderId"
        [isRentalsSearchOption]="data.isRentalsSearchOption">
    </saved-search-form>

    <div class="saved-search-edit-footer">

        @if (data.savedSearch != null) {

        <rpc-button class="saved-search-edit-footer-item saved-search-edit-footer-item--delete"
            [appearanceType]="'stroke'" [iconName]="'delete-bin'" [color]="'warn'"
            [text]="'ADD_EDIT_SAVED_SEARCH_DIALOG.BUTTONS.DELETE'" (clicked)="onDeleteSavedSearch()">
        </rpc-button>

        }

        <rpc-button class="saved-search-edit-footer-item saved-search-edit-footer-item--cancel"
            [appearanceType]="'stroke'" [text]="'ADD_EDIT_SAVED_SEARCH_DIALOG.BUTTONS.CANCEL'" (clicked)="onClose()">
        </rpc-button>

        <rpc-button class="saved-search-edit-footer-item saved-search-edit-footer-item--submit"
            [text]="data.savedSearch != null ? 'ADD_EDIT_SAVED_SEARCH_DIALOG.BUTTONS.SAVE' : 'ADD_EDIT_SAVED_SEARCH_DIALOG.BUTTONS.CREATE'"
            [appearanceType]="'flat'" [color]="'accent'" [disabled]="isFormInvalid" (clicked)="onSave()">
        </rpc-button>

    </div>

</div>